import TemplateIcon from "src/components/ui-icons/menu/myTasks/TemplateIcon";
import { ConfigureIcon, ErrorsIcon, StatisticIcon, UsersIcon } from "../components/ui-icons/menu";
import HeaderLayout from "../layouts/HeaderLayout";

import FoldersIcon from "src/components/ui-icons/menu/myTasks/FoldersIcon";

const supplyAdminList = [
  { icon: <ConfigureIcon />, text: "Все настройки" },
  { icon: <StatisticIcon />, text: "Статистика" },
  { icon: <UsersIcon />, text: "Пользователи" },
  { icon: <ErrorsIcon />, text: "Ошибки" },
];

const myDocumentsAdminList = [
  { icon: <ConfigureIcon />, text: "Все настройки" },
  { icon: <UsersIcon />, text: "Пользователи" },
  { icon: <FoldersIcon />, text: "Коллекции" },
  { icon: <TemplateIcon />, text: "Шаблоны" },
  { icon: <StatisticIcon />, text: "Статистика" },
  { icon: <ErrorsIcon />, text: "Шаблоны" },
];

function AdminPage() {
  return (
    <HeaderLayout>
      <div className="container mx-auto max-md:px-7.5 px-10">
        <div className="flex flex-row ">
          <div className="flex flex-col grow">
            <div className="flex flex-row mb-8">
              <span className="text text-[40px] max-sm:text-[20px] font-bold text-black">Панель администратора</span>
            </div>
            <div className="flex flex-row flex-wrap sm:-mx-[15px]">
              <div className="flex flex-col sm:px-[15px] shrink pb-7.5 sm:w-1/2 w-full">
                <div className="bg-white px-5  sm:px-7.5 shadow-custom pt-[25px] pb-7.5">
                  <h3 className="text-black">Supply Portal</h3>

                  <div className="flex flex-row mt-7.5">
                    <div className="flex flex-col grow gap-2.5">
                      {supplyAdminList.map((button) => (
                        <div className="flex flex-row gap-3 border py-[18px] px-5 rounded-lg items-center">
                          <div className="flex flex-col">{button.icon}</div>
                          <div className="flex flex-col text-[#637381]">{button.text}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:px-[15px] shrink pb-7.5 w-1/2 max-sm:w-full">
                <div className="bg-white  px-5  sm:px-7.5 shadow-custom pt-[25px] pb-7.5">
                  <h3 className="text-black">Мои документы</h3>
                  <div className="flex flex-row mt-7.5">
                    <div className="flex flex-col grow gap-2.5">
                      {myDocumentsAdminList.map((button) => (
                        <div className="flex flex-row gap-3 border py-[18px] px-5 rounded-lg items-center">
                          <div className="flex flex-col">{button.icon}</div>
                          <div className="flex flex-col text-[#637381]">{button.text}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeaderLayout>
  );
}

export default AdminPage;
